import api from '../..'
// import { ObjectToFormDataWithFiles, decamelizeThatDontBreaksFile } from '../../../helpers/converters.helper';

const destroyLesson = (lessonId: number) => {
  return api.delete(`administration/lessons/${lessonId}`)
}

export default destroyLesson
